import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";
import $api from "./openapi";
import useSetSelectedQuoteRevisionId from "../SelectedQuoteRevisionIdContext/useSetSelectedQuoteRevisionId";
import useToPage from "../useToPage";

export default function useCreateQuoteRevision() {
  const { toRfq } = useToPage();
  const { teamSlug, rfqId } = useParams();
  const queryClient = useQueryClient();
  const setSelectedQuoteRevisionId = useSetSelectedQuoteRevisionId();

  const { mutate } = $api.useMutation(
    "post",
    "/api/teams/{team_slug}/quote_revisions",
    {
      onSuccess: ({ id }) => {
        queryClient.invalidateQueries({
          queryKey: ["get", "/api/teams/{team_slug}/rfqs/{id}/full"],
        });
        setSelectedQuoteRevisionId(id);
        toRfq();
      },
    },
  );

  return () =>
    mutate({
      params: {
        path: { team_slug: teamSlug! },
      },
      body: {
        rfq_id: rfqId!,
      },
    });
}
